import { useState } from "react";

import { RoleGate } from "@/components/RoleGate";
import {
  useAddAuditRecipient,
  useAuditRecipients,
  useRemoveAuditRecipient,
} from "@/hooks/useApi";

export function AuditRecipientsPage() {
  return (
    <RoleGate allowed={["admin", "auditor"]}>
      <Inner />
    </RoleGate>
  );
}

function Inner() {
  const { data, isLoading } = useAuditRecipients();
  const add = useAddAuditRecipient();
  const remove = useRemoveAuditRecipient();
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");

  async function handleAdd() {
    if (!email.trim()) return;
    await add.mutateAsync({ email: email.trim().toLowerCase(), nome: nome.trim() || undefined });
    setEmail("");
    setNome("");
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-semibold">Destinatários do audit semanal</h2>
        <p className="text-sm text-ink-muted">
          E-mails que recebem o relatório de giro toda sexta às 17h.
        </p>
      </div>

      <div className="card p-4">
        <h3 className="font-display text-base font-semibold">Adicionar destinatário</h3>
        <div className="mt-3 flex flex-wrap gap-3">
          <input
            className="input max-w-md flex-1"
            type="email"
            placeholder="email@grupoanarosa.org.br"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className="input max-w-xs"
            placeholder="Nome (opcional)"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <button
            className="btn-primary"
            disabled={!email || add.isPending}
            onClick={handleAdd}
          >
            {add.isPending ? "Adicionando…" : "Adicionar"}
          </button>
        </div>
        {add.error ? (
          <p className="mt-2 text-sm text-anarosa">Erro ao adicionar destinatário.</p>
        ) : null}
      </div>

      {isLoading ? <p className="text-ink-muted">Carregando…</p> : null}
      {data ? (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-ink-muted">
              <tr>
                <th className="px-4 py-3">E-mail</th>
                <th className="px-4 py-3">Nome</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.map((r) => (
                <tr key={r.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 font-mono text-xs">{r.email}</td>
                  <td className="px-4 py-2">{r.nome ?? "—"}</td>
                  <td className="px-4 py-2">
                    <span className={r.ativo ? "badge-alto-custo" : "badge-ordinario"}>
                      {r.ativo ? "Ativo" : "Inativo"}
                    </span>
                  </td>
                  <td className="px-4 py-2 text-right">
                    <button
                      className="text-sm text-anarosa hover:underline"
                      onClick={() => remove.mutate(r.id)}
                    >
                      Remover
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
